import { useTranslation } from "react-i18next";
import ThemeSwitcher from "./ThemeSwitcher";

const Narvar = () => {
  const { t } = useTranslation();
  return (
    <nav className="navbar w-full max-w-2xl mx-auto px-4 py-3 bg-white/80 backdrop-blur-sm border-b border-navy-100">
      <div className="flex-1">
        <a 
          href="https://linkcitos.netlify.app/"
          className="btn btn-ghost normal-case text-xl font-bold tracking-tight hover:bg-transparent hover:scale-105 transition-transform duration-300"
        >
          <span className="bg-gradient-to-r from-accent to-navy-600 bg-clip-text text-transparent">
            {t("title.narvar")}
          </span>
        </a>
      </div>
      <div className="flex-none flex items-center gap-2">
        <ThemeSwitcher />
        <div className="badge badge-outline badge-sm font-mono">v0.1.1</div>
      </div>
    </nav>
  );
};

export default Narvar;
